import { gql } from '@apollo/client';
/**
 * @const PartnerFormQuery
 * @since 1.0.0
 * Partner whose dynamic sales form is enabled under the slug, null otherwise.
 */
export const PartnerFormQuery = gql `
  query PartnerFormQuery($input: PartnerStoreInput!) {
    partnerForm(input: $input) {
      id
      name
      image {
        id
        url
      }
    }
  }
`;
